// extracted by mini-css-extract-plugin
export default {"font-en":"styles_font-en__OfDep"};